import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { getMe } from "../api/client";
import Spinner from "react-bootstrap/Spinner";

/**
 * ProtectedRoute component that checks user authentication and role
 * @param {React.ReactNode} children - The component to render if authorized
 * @param {string} allowedRole - The role required to access this route ("student" or "teacher")
 */
export default function ProtectedRoute({ children, allowedRole }) {
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          setUser(null);
          setLoading(false);
          return;
        }

        const me = await getMe();
        setUser(me);
      } catch (err) {
        console.error("Auth check failed:", err);
        setUser(null);
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
  }, []);

  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: "50vh", backgroundColor: "var(--bg-secondary)" }}
      >
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  // Not logged in - redirect to login
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Check role
  const userRole = user.user_type;

  if (allowedRole && userRole !== allowedRole) {
    // Redirect to appropriate dashboard based on actual role
    if (userRole === "teacher") {
      return <Navigate to="/TeacherDashboard" replace />;
    } else if (userRole === "student") {
      return <Navigate to="/StudentDashboard" replace />;
    } else {
      return <Navigate to="/login" replace />;
    }
  }

  return children;
}
